import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import { useListCustomers } from "../../../../api/customer-api";
import { useUiFeedback } from "../../../../context/ui-feedback/ui-feedback";
import { createErrorFeedback } from "../../../../context/ui-feedback/action";
import { Loading } from "../../../common/loading/loading";

export const CustomerSelector = ({ selected, error, handleChange }) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { uiFeedbackDispatch } = useUiFeedback();

  const [customers, setCustomers] = useState(null);

  const listCustomers = useListCustomers();

  useMemo(() => {
    const loadCustumersFromServer = async () => {
      try {
        await listCustomers((data) => {
          if (data instanceof Error) {
            throw data;
          } else {
            data.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
            setCustomers(data);
          }
        });
      } catch (ex) {
        if (ex.response?.status === 401 || ex.response?.status === 403) {
          navigate("/");
        } else {
          createErrorFeedback(
            uiFeedbackDispatch,
            intl.formatMessage({
              id: "page.onsiteserviceworksheets.exception.listcustomers.title",
            }),
            intl.formatMessage({
              id: "page.onsiteserviceworksheets.exception.listcustomers.description",
            }),
          );
        }
      }
    };

    loadCustumersFromServer();
  }, [intl, listCustomers, navigate, uiFeedbackDispatch]);

  if (!customers) {
    return <Loading />;
  }

  return (
    <>
      <Form.Select
        value={selected ? selected : 0}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
      >
        {selected ? null : (
          <option value="0">
            <FormattedMessage id="page.onsiteserviceworksheets.form.customer.null" />
          </option>
        )}
        {customers.map((customer) => (
          <option key={customer.id} value={customer.id}>
            {customer.name} ({customer.number})
          </option>
        ))}
      </Form.Select>
      <div className={`invalid-feedback${error ? " d-block" : ""}`}>
        <FormattedMessage id="page.onsiteserviceworksheets.exception.missingcustomer.title" />
      </div>
    </>
  );
};

CustomerSelector.propTypes = {
  selected: PropTypes.string,
  error: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};
